import React, { Fragment } from 'react'
import type { Props } from './types'
import { ImageMedia } from './ImageMedia'
import { VideoMedia } from './VideoMedia'
import { getServerSideURL } from '@/utilities/getURL'
import { slimMedia } from '@/utilities/slimMedia'

const VIDEO_EXTENSIONS = ['.mp4', '.webm', '.ogg', '.mov', '.avi']

const isVideoByExtension = (str: string | null | undefined): boolean => {
  if (!str) return false
  const clean = str.toLowerCase().split('?')[0] ?? ''
  return VIDEO_EXTENSIONS.some((ext) => clean.endsWith(ext))
}

export const Media: React.FC<Props> = (props) => {
  const { className, htmlElement = 'div', resource } = props

  if (!resource) return null

  const isVideo =
    typeof resource === 'object' &&
    (resource?.mimeType?.startsWith('video/') ||
      isVideoByExtension(resource?.filename) ||
      isVideoByExtension(resource?.url))

  const Tag = htmlElement || Fragment

  const imageObjectJsonLd =
    !isVideo && typeof resource === 'object' && resource.description
      ? {
          '@context': 'https://schema.org',
          '@type': 'ImageObject',
          ...(resource.title && { name: resource.title }),
          description: resource.description,
          contentUrl: `${getServerSideURL()}${resource.url}`,
        }
      : null

  return (
    <Tag
      {...(htmlElement !== null
        ? {
            className,
          }
        : {})}
    >
      {imageObjectJsonLd && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(imageObjectJsonLd) }}
        />
      )}
      {/* ImageMedia and VideoMedia are client components: whatever `resource`
          holds here is serialised into the HTML, so hand them only the fields
          they render. */}
      {isVideo ? (
        <VideoMedia {...props} resource={slimMedia(resource)} />
      ) : (
        <ImageMedia {...props} resource={slimMedia(resource)} />
      )}
    </Tag>
  )
}
